import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from "@angular/common/http";


@Injectable()
export class PaymentService {

  baseUrl: string = environment.api_base_url;
  // baseUrl: string = 'http://192.168.8.100:8000/api/';

  constructor(public http: HttpClient) {

  }

  getInstallments(data): any {
    return this.http.post(`${this.baseUrl}installments/generate`, JSON.stringify(data));
  }

  getOfferPdf(data): any {
    return this.http.post(
      `${this.baseUrl}projectsOfferImages/generate_file`,
      JSON.stringify(data)
    );
  }

  refundRequestPayment(id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/refund_request_payment`,
      payload
    );
  }

  approveRefundRequestPayment(id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/approve_refund_request_payment`,
      payload
    );
  }

  rejectRefundRequestPayment(id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/reject_refund_request_payment`,
      payload
    );
  }

  cdbRequestCrPaymentRefund(id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/cdb_request_cr_payment_refund`,
      payload
    );
  }

  cdbApproveCrPaymentRefund(id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/cdb_approve_cr_payment_refund`,
      payload
    );
  }

  cdbRejectCrPaymentRefund(id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/cdb_reject_cr_payment_refund`,
      payload
    );
  }

  splitCdbPayment(id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${id}/split_cdb_payment`,
      payload
    );
  }

  redepositRequestStatus(payment, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${payment}/redeposit_request_status`,
      payload
    );
  }

  approveRedepositRequest(payment, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${payment}/approve_redeposit_request`,
      payload
    );
  }

  rejectRedepositRequest(payment, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}paymentCollections/${payment}/reject_redeposit_request`,
      payload
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payment/payment.service.ts